// extracted by mini-css-extract-plugin
export default {"form":"FormLayout_form__swzpQ","row":"FormLayout_row__itPkD","col":"FormLayout_col__xwa6E"};